import React from "react";
import Responsive from "react-responsive";
import { breakpoints } from "./MobileBreakpoints";

export const MobileDown = (props: any) => (
  <Responsive {...props} maxWidth={breakpoints.tablet - 1} />
);

export const TabletDown = (props: any) => (
  <Responsive {...props} maxWidth={breakpoints.tablet - 1} />
);

export const LaptopDown = (props: any) => (
  <Responsive {...props} maxWidth={breakpoints.laptop - 1} />
);

export const LaptopLDown = (props: any) => (
  <Responsive {...props} maxWidth={breakpoints.laptopL - 1} />
);

export const TabletToLaptop = (props: any) => (
  <Responsive
    {...props}
    minWidth={breakpoints.tablet}
    maxWidth={breakpoints.laptop - 1}
  />
);

export const TabletUp = (props: any) => (
  <Responsive {...props} minWidth={breakpoints.tablet} />
);

export const LaptopUp = (props: any) => (
  <Responsive {...props} minWidth={breakpoints.laptop} />
);

export const LaptopLUp = (props: any) => (
  <Responsive {...props} minWidth={breakpoints.laptopL} />
);
